
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//录入模板列表
export async function getTemplatesList(params) {
    return post(erpserver+'/template/getTemplatesList', params, true)
}
//录入模板编辑新增
export async function addTemplate(params) {
    return post(erpserver+'/template/saveTemplate', params, true)
}
//录入模板作废验证
export async function templateUsed(params) {
    return post(erpserver+'/template/templateUsed', params, true)
}
//录入模板作废
export async function voidTemplate(params) {
    return post(erpserver+'/template/voidTemplate', params, true)
}